import React from 'react'
import { NavLink } from 'react-router-dom'


const Button = props => {

	const {
		children,
		className="",
		disabled,
		exact,
		href,
		onClick,
		target,
		to,
		type="button"
	} = props

	if (href) {
		return (
			<a
				href={href}
				target={target}
				className={`BTN ${className}`}
			>
				{children}
			</a>
		)
	}

	if (to) {
		return (
			<NavLink
				to={to}
				exact={exact}
				target={target}
				className={`BTN ${className}`}
			>
				{children}
			</NavLink>
		)
	}

	return (
		<button
			type={type}
			onClick={onClick}
			disabled={disabled}
			className={`BTN ${className}`}
		>
			{children}
		</button>
	)

}


export default Button
